import apiClient from 'utils/apiClient';
import { useSWRConfig } from 'swr';
import API_BASE_URL from 'config/api';

export default function useCreate(endpoint) {
  const { mutate } = useSWRConfig();

  const create = async (payload, opts = { revalidate: true }) => {
    const res = await apiClient.post(endpoint, payload);
    if (opts.revalidate) await mutate(endpoint);
    return res.data;
  };

  return { create };
}
